<template>
    <div style="background-color: #f2f1f7;overflow: hidden;">
        <div class="headBox">
            <img src="../../assets/img/return.png" alt="" class="refund" @click="refund">
            <img src="../../assets/img/logo.png" alt="">
            <div class="siteName">
                案件管理系统
                <span>企业端</span>
            </div>
        </div>
<!--        签署区-->
        <div style="height: 93vh;overflow: scroll">
            <signingArea></signingArea>
        </div>
    </div>
</template>

<script>
    import signingArea from './components/signingArea'
    export default {
        name: 'signPage',
        methods: {
            //返回前一页
            refund() {
                this.$router.back()
            }
        },
        components:{
            signingArea
        }
    };
</script>

<style scoped>
    .headBox {
        display: flex;
        align-items: center;
        height: 65px;
        background-color: #2350b5;
    }

    .refund {
        height: 24px;
        margin-left: 10px;
        margin-right: 50px;
        cursor: pointer;
    }

    .siteName {
        margin: 0px 35px;
        font-size: 22px;
        color: #fff;
    }

    .siteName > span {
        font-size: 14px;
        font-weight: 600;
        margin-left: 20px;
    }
</style>
